import React from 'react';
import './css/StaffPicks.css';
import { StaffPicksCardTitle } from './cards/StaffPicksCardTitle';
import { FormattedMessage } from 'react-intl';

const StaffPicks = ({ blogData, textTitle }) => {
  return (
    <div className="container_staff_picks">
      <FormattedMessage id={textTitle ? textTitle : '     '} />
      {blogData.map((item, index) => (
        <StaffPicksCardTitle key={index} cardData={item} />
      ))}
    </div>
  );
};

export default StaffPicks;
